var settingsSwiperShowroom = {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: false,
  centeredSlides: true,
  pagination: {
    el: ".js-showroom-swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".js-showroom-swiper-button-next",
    prevEl: ".js-showroom-swiper-button-prev"
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 1,
      centeredSlides: false,
    },
  },
}
var swiperShowroom = new Swiper(".showroomSwiper", settingsSwiperShowroom);

function functionChangeItem (elemento, data) {
  event.preventDefault();
  swiperShowroom.slideTo(data);

  const list = document.querySelector(".c-showroom__list--desktop");
  list.classList.add('active');

  const bullets = document.querySelectorAll(".c-showroom__point");
  bullets.forEach(bullet => {
    bullet.classList.remove('active');
  });
  elemento.classList.add('active');
} 


var settingsSwiperShowroomMobile = {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: false,
  centeredSlides: true,
  pagination: {
    el: ".js-showroom-mobile-swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".js-showroom-mobile-swiper-button-next",
    prevEl: ".js-showroom-mobile-swiper-button-prev"
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    768: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    1024: {
      slidesPerView: 1,
      centeredSlides: false,
    },
  },
}

var swiperShowroomMobile = new Swiper("body .showroomSwiperMobile", settingsSwiperShowroomMobile);

function functionChangeItemMobile (elemento, data) {
  event.preventDefault();
  swiperShowroomMobile.slideTo(data);
  //
  const list = document.getElementById("list-showroom");
  list.classList.add('active');

  const bullets = document.querySelectorAll(".c-showroom__point");
  bullets.forEach(bullet => {
    bullet.classList.remove('active');
  });
  elemento.classList.add('active');
}

function functionCloseMobile () {
  event.preventDefault();
  const list = document.getElementById("list-showroom");
  list.classList.remove('active');
}

// selecting the element
let items = document.querySelectorAll('.card-id');

for (let i = 0; i < items.length; i++) {
  // Add class to the element
  items[i].addEventListener('click', function() {
    items[i].classList.toggle('active');
  });
}

let tabs = document.querySelectorAll('.s-afiliados__list-item');

for (let i = 0; i < tabs.length; i++) {
  // Add class to the element
  tabs[i].addEventListener('click', function() {
    let item = document.querySelector('.s-afiliados__list-item');
    let siblings = item.parentNode.querySelectorAll(':scope > :not(.s-afiliados__list-item)');
    for (let z = 0; z < siblings.length; z++) {
        siblings[z].classList.remove('active');
    }
    tabs[i].classList.add('active');
  });
}

function openTabs(evt) {
  evt.preventDefault();
  var i, tabcontent;
  tabcontent = document.querySelectorAll('.s-afiliados__list-item');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }
  evt.currentTarget.classList.add('active');
}

function openTabsGuide(evt) {
  evt.preventDefault();
  var i, tabcontent;
  tabcontent = document.querySelectorAll('.size-chart__list-item');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove("active");
  }
  evt.currentTarget.classList.add('active');
}

/* Change Image - Click variant */
/* -------------------------------------------------------------------------------------- */

function showImageVariant(event) {
  event.preventDefault();
  let imagenURL = event.currentTarget.dataset.background;
  var imagen = document.createElement('img');
  let imagenWrapper = event.currentTarget.closest(".block-inner-inner").querySelector('.c-product-card__image-color');
  let imagenSlider = event.currentTarget.closest(".block-inner-inner").querySelectorAll('.product-block__image');
  imagen.className = 'c-product-card__image-variant-color';
  imagen.src = imagenURL;
  if (imagenWrapper.hasChildNodes()) {
    imagenWrapper.removeChild(imagenWrapper.firstElementChild);
  }
  imagenWrapper.appendChild(imagen);
  imagenSlider.forEach((item, index) => {
    if(index==0){
    item.classList.add('product-block__image--active');
    }else{
      item.classList.remove('product-block__image--active');
    }
  });
}